import { SVGProps } from 'react';

import { translation, TranslatedComponent, numberFormatter } from '@hh.ru/front-static-app';

import { StatisticDetailItem } from 'src/models/pages/profession';
import pluralize from 'src/utils/pluralize';

import {
    BAR_DASH_HEIGHT,
    BAR_DASH_PADDING,
} from 'src/pages/Profession/components/SectionStatistics/DetailChart/Chart/constants';

const TrlKeys = {
    profession: {
        one: 'career-platform.pluralize.vacancy.one',
        some: 'career-platform.pluralize.vacancy.some',
        many: 'career-platform.pluralize.vacancy.many',
    },
};

type Props = {
    // rechart render props
    index: number;
    className: string;
    value: StatisticDetailItem['count'];
    payload: StatisticDetailItem;
    background: {
        x: number;
        y: number;
        width: number;
        height: number;
    };
    tooltipPosition: {
        x: number;
        y: number;
    };
    // ... other see props in debug
} & SVGProps<unknown> &
    StatisticDetailItem;

const CustomBarShape: TranslatedComponent<Props> = (props) => {
    const { x, y, width, height, radius, value, background, className, trls } = props;

    if (!x || !y || !width || !height || !radius) {
        return null;
    }

    const contentWidth = +width - BAR_DASH_PADDING * 2;

    return (
        <g className={className} transform={`translate(${x}, 0)`}>
            <rect className="chart-bar-background" width={width} height={background.height} />
            <g transform={`translate(0, ${background.height - +height})`}>
                <rect className="chart-bar-figure" width={width} height={height} rx={radius} />
                <rect
                    className="chart-bar-figure-dash"
                    x={BAR_DASH_PADDING}
                    y={BAR_DASH_PADDING}
                    width={contentWidth}
                    height={BAR_DASH_HEIGHT}
                    rx={+radius / 2}
                />
                {!!value && (
                    <g transform="translate(0, 32)">
                        <text
                            className="chart-bar-figure-count"
                            width={contentWidth}
                            x={+width / 2}
                            textAnchor="middle"
                            dominantBaseline="middle"
                        >
                            {numberFormatter.format(value.toString())}
                        </text>
                        <text
                            className="chart-bar-figure-vacancies"
                            y={14}
                            width={contentWidth}
                            x={+width / 2}
                            textAnchor="middle"
                            dominantBaseline="middle"
                        >
                            {pluralize({
                                count: value,
                                one: trls[TrlKeys.profession.one],
                                some: trls[TrlKeys.profession.some],
                                many: trls[TrlKeys.profession.many],
                            })}
                        </text>
                    </g>
                )}
            </g>
        </g>
    );
};

export default translation(CustomBarShape);
